/**
 * Session Goal types — daily rotating objectives
 */

import { Quality } from './enums';

/**
 * Types of session goals
 */
export enum SessionGoalType {
  CATCH_FISH = 'catch_fish',
  CATCH_SPECIES = 'catch_species',
  CATCH_QUALITY = 'catch_quality',
  EARN_GOLD = 'earn_gold',
  SELL_FISH = 'sell_fish',
  SWEET_SPOT_HITS = 'sweet_spot_hits',
  PULL_TRAPS = 'pull_traps',
  CATCH_CRUSTACEANS = 'catch_crustaceans',
}

/**
 * A single session goal instance (runtime state)
 */
export interface SessionGoal {
  id: string;
  description: string;
  type: SessionGoalType;
  targetValue: number;
  currentValue: number;
  completed: boolean;
  rewardGold: number;
  rewardXP: number;
  speciesId?: string;
  minQuality?: Quality;
}

/**
 * Persisted session goal state
 */
export interface SessionGoalState {
  goals: SessionGoal[];
  lastResetDate: string;       // ISO date "2026-02-13"
  totalGoalsCompleted: number; // Lifetime counter
}
